module.exports = __webpack_public_path__ + "static/img/COC2023-15.1654a9a.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/meeting2023/COC2023-15.png
// module id = kAsO
// module chunks = 0